import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import { useLocation, useParams } from 'react-router-dom'

import { Window, SettingsContext } from "../../contexts"
import { Header } from "./index.jsx"


const parseLocation = (firstParam, secondParam, location) => {
  let type, step

  // Sign-up from invitation: /create-account/invitation/{code}
  if (firstParam === 'invitation') {
    type = Window.INVITED_USER.is_client ? 'client' : 'member';
    step = 1

    return { type, step }
  }

  // Client sign-up after step 1: /create-account/step-{no}
  if (firstParam && firstParam.split('-')[0] === 'step') {
    type = 'client'
    step = parseInt(firstParam.split('-')[1])

    return { type, step }
  }

  // Member sign-up: /create-account/member, /create-account/member/step-2
  if (firstParam === 'member') {
    type = 'member'
    step = secondParam ? parseInt(secondParam.split('-')[1]) : 1;

    return { type, step }
  }

  const path = location.pathname.substr(1)

  // Client sign-in step 1: /create-account
  if (path === 'create-account') {
    type = 'client'
    step = 1

    return { type, step }
  }

  // Sign-in, Account recovery: /sign-in, /recover-account, etc.
  return {
    type: path,
    step: 1
  }
}

const AuthenticationLayout = ({ noVideo, ...props}) => {
  const { isRetailCircle, retailCircleToken, isShopify } = useContext(SettingsContext);
  const { firstParam, secondParam } = useParams();
  const location = useLocation();
  const history = useHistory();

  const Content = props.content
  const className = props.className || '';
  const { type, step } = parseLocation(firstParam, secondParam, location)

  const containerClasses = isShopify ? "col-12" : "col-md-8 col-lg-6";

  return (
    <main id='authentication' className={`flex-grow-1 d-flex flex-column ${type} ${type}-${step} ${className}`}>
      <div className="container-fluid d-flex flex-column flex-grow-1">
        <div className="row">
          <div className={containerClasses}>
            <div className="flex-grow-1 d-flex flex-column">
              {!isShopify && !isRetailCircle && <Header {...{type, step}} {...props.context} />}

              <div className="container-fluid flex-grow-1">
                <div className="body-ct">
                  {isRetailCircle && !isShopify && <Header {...{type, step}} {...props.context} />}
                  <Content {...{type, step}} {...props.context} />
                </div>
              </div>
            </div>
          </div>

          {!isShopify && (
            <div className="d-none d-md-table-row col-md-4 col-lg-6">
              <div className="video auth-bg min-vh-100" />
            </div>
          )}

        </div>
      </div>
    </main>
  )
}

export default AuthenticationLayout
